var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"227860485f305a15ac36cf87f5e6b7b71a815885"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["base-frontend@good-it-works"]={id:"227860485f305a15ac36cf87f5e6b7b71a815885"};
      